import { TypographyHeading } from "shared/molecules/typography-layout";
import { Nl3LiveclassMasterFilter } from "./filter";
import { Box, InputLabel, Paper, Typography, FormControl, Select, MenuItem, Pagination } from "@mui/material";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { GET_LIVECLASS_MASTERS } from "utils/graphql/services/live-classes/queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import NoDataFound from "shared/molecules/no-data";
import {Stack} from "@mui/material"
import {table} from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import { UPDATE_NLEARN3_LIVECLASS_MASTER } from "utils/graphql/services/live-classes/mutations";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";
import { utcToIst } from "utils/time-util/utcIstTime";

export default function Nl3LiveclassMaster() {

    const [searchPayload, setSearchPayload] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    
    const [updateLiveclassMaster] = useMutation(UPDATE_NLEARN3_LIVECLASS_MASTER, {
        client: liveClassClientService,
    });

    async function handleDisable(row: any) {
      try {
        await updateLiveclassMaster({
          variables: {
            input: {
              id: row.id,
              markAsDeleted: true,
            },
          },
        });
        getLiveclassMastersList({
          variables: {
            input: {
              limit: limit,
              offset: (page - 1) * limit,
              ...searchPayload,
            },
          },
        });
      } catch (err) {
        console.error("Error disabling liveclass master:", err);
      }
    }

    async function handleEnable(row: any) {
      try {
        await updateLiveclassMaster({
          variables: {
            input: {
              id: row.id,
              markAsDeleted: false,
            },
          },
        });
        getLiveclassMastersList({
          variables: {
            input: {
              limit: limit,
              offset: (page - 1) * limit,
              ...searchPayload,
            },
          },
        });
      } catch (err) {
        console.error("Error enabling liveclass master:", err);
      }
    }
    const [getLiveclassMastersList, { loading, error, data }] = useLazyQuery(
        GET_LIVECLASS_MASTERS,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        getLiveclassMastersList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);
    
    const liveclassMasterData = data?.getLiveclassMasters?.liveclassMasters?.map((item: any) => ({
        ...item,
        recordedVideoMaxVisibleDate: utcToIst(item.recordedVideoMaxVisibleDate),
        createdAt: utcToIst(item.createdAt),
        updatedAt: utcToIst(item.updatedAt),
    })) || []

    return (
        <>
            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Liveclass Masters{" "}
            </TypographyHeading>

            <Nl3LiveclassMasterFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset to first page
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getLiveclassMasters?.liveclassMasters?.length > 0 ? (
                        <CollapsibleTable
                            data={liveclassMasterData || []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getLiveclassMasters?.totalCount || 0}
                            paginationSegmentApi="false"
                            viewSecondaryData="true"
                            showPaginationFooter={false}
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Pagination
                            count={Math.ceil(data?.getLiveclassMasters?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>

            </Paper>
        </>
    )
}
